module.exports = __webpack_public_path__ + "img/_DSC2019.8872dbbf.jpg";